import { render, staticRenderFns } from "./SubmitingPlaceholder.vue?vue&type=template&id=4b8fd150&scoped=true"
import script from "./SubmitingPlaceholder.vue?vue&type=script&lang=js"
export * from "./SubmitingPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./SubmitingPlaceholder.vue?vue&type=style&index=0&id=4b8fd150&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8fd150",
  null
  
)

export default component.exports